var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GraphElement_1;
import { Utils } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { graphElementSchemaValidation } from '../validations.generated';
export const graphElementSchema = {
    $id: 'urn:wisepipe-common-pipe:GraphElement',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        elementType: { type: 'string', pattern: 'edge|node|group' },
        lastModified: { type: 'string', format: 'date-time' },
        uniqueChangeID: { type: 'string' }
    },
    required: ['elementID', 'elementType']
};
let GraphElement = GraphElement_1 = class GraphElement {
    constructor(elementID, elementType, lastModified, uniqueChangeID) {
        this.elementID = elementID;
        this.elementType = elementType;
        this.uniqueChangeID = uniqueChangeID;
        if (lastModified !== undefined) {
            this.lastModified = lastModified;
        }
        JSON.validate(this, GraphElement_1);
    }
    static validateElementID(elementID) {
        class ID extends GraphElement_1 {
            constructor(elementID) {
                super(elementID, 'edge');
            }
        }
        new ID(elementID);
    }
    static newID() {
        return Utils.newID(10);
    }
    static bufferID(elementID) {
        return Utils.base64StringToBuffer(elementID);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], GraphElement.prototype, "lastModified", void 0);
GraphElement = GraphElement_1 = __decorate([
    JsonSchemaV2(graphElementSchema, graphElementSchemaValidation),
    JsonDiscriminatorProperty('elementType')
], GraphElement);
export { GraphElement };
//# sourceMappingURL=graphElement.js.map